var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.407,
    height: 21.5,
    viewBox: "0 0 21.407 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_84380",
    "data-name": 84380,
    transform: "translate(-0.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M109.084.725,109.058.7a2.679,2.679,0,0,0-3.785.171L95.7,11.353a.924.924,0,0,0-.194.331L94.38,15.059A1.283,1.283,0,0,0,95.6,16.748h0a1.278,1.278,0,0,0,.515-.108l3.259-1.426a.923.923,0,0,0,.312-.223L109.256,4.51A2.682,2.682,0,0,0,109.084.725ZM96.537,14.436l.661-1.98.056-.061,1.252,1.144-.056.061ZM107.891,3.263l-8.139,8.91L98.5,11.029l8.139-8.91a.83.83,0,0,1,1.173-.053l.026.024A.831.831,0,0,1,107.891,3.263Z",
    transform: "translate(-87.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M19.435,38.806a.924.924,0,0,0-.924.924v7.848a2.354,2.354,0,0,1-2.351,2.351H4.957a2.353,2.353,0,0,1-2.351-2.351V36.466a2.354,2.354,0,0,1,2.351-2.351h8.109a.924.924,0,0,0,0-1.849H4.957a4.2,4.2,0,0,0-4.2,4.2V47.578a4.2,4.2,0,0,0,4.2,4.2h11.2a4.2,4.2,0,0,0,4.2-4.2V39.73A.924.924,0,0,0,19.435,38.806Z",
    transform: "translate(0 -30.278)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3272f0a2.svg";
export { ForwardRef as ReactComponent };